import { LogLevel } from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_CLIENT_ID || "", // This is the ONLY mandatory field that you need to supply.
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8", // Replace the placeholder with your tenant subdomain
    redirectUri: "/", // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  articleListApi: {
    endpoint: process.env.NEXT_PUBLIC_BACKEND_BASE_URL,
    scopes: {
      read: [process.env.NEXT_PUBLIC_BACKEND_SCOPE],
    },
    urls: {
      getSections: "/api/v1/sections/",
      getSectionsWithDepartments: "/api/v1/sections/sectionwithdepartment/",
      getSeasons: "/api/v1/seasons/current/3/3", // 3 is previous season and 3 is next season
      getArticleList: "/api/v1/articles/", // pass season and department as query params,
      getArticleOverviewMultiple: "/api/v1/article/overview",
      getArticleCommonMultiple: "/api/v1/article/common",
      redirectUrl: "/api/v1/RedirectUrl",
      getQuantificationData: "/api/v1/quantification/getdataforarticles",
      getBuildingBlockData: "/api/v1/buildingblock",
      // Sales-strategy attribute definitions: code -> display text, used to resolve values
      // the granular lane delivers as codes (pipe). Global — no season or department — so
      // this is fetched once per page load.
      getSalesStrategyAttributeDefinitions:
        "/api/v1/salesstrategy/attribute-definitions",
      // GAM endpoints
      verifyGamUser: "/api/v1/access/isassortmentlistuser",
      // getUserFunctions: '/api/v1/gam/user-functions',
    },
  },
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...protectedResources.articleListApi.scopes.read],
};

export const msalInstance = new PublicClientApplication(msalConfig);
